<template>
  <footer class="foot">

    <div class="foot-one">
      <div class="foot-logo">
        <a href="/"><img src="/images/foot/foot_logo.png" alt="北京西宝电子技术有限责任公司"></a>
      </div>
      <div class="foot-info">
        <div class="foot-item-left">
          <div class="foot-item">
            <span class="foot-item-title">联系地址：</span>
            <div class="foot-desc">
              北京市海淀区学清路8号科技财富中心 B座308-309室
            </div>
          </div>
          <div class="foot-item">
            <span class="foot-item-title">传真：</span>
            <div class="foot-desc">
              010 - 62316463
            </div>
          </div>
          <div class="foot-item">
            <span class="foot-item-title">联系电话：</span>
            <div class="foot-desc">
              010 - 62312909
            </div>
          </div>

          <div class="foot-item">
            <span class="foot-item-title">邮箱：</span>
            <div class="foot-desc">
              sales@beijingxibao.com
            </div>
          </div>
        </div>
        <div class="foot-item-right">
          <img src="/images/footImg/wechat.png" style="width: 132px; height: 132px;" alt="微信"  >
          <img src="/images/footImg/xcx.png" style="width: 132px; height: 132px;" alt="微信"  >

<!-- 
          <el-popover placement="top-start" width="230" trigger="hover">
            <QRCode alt="" codeName="二维码"
              content="https://connect.qq.com/widget/shareqq/index.html?url=http%3A%2F%2Fwww.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8&desc=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8"
               :width="'200'" :height="'200'"></QRCode>
            <img slot="reference" src="/images/foot/1.png" alt="QQ"  class="social-icon">
          </el-popover> -->




          <!-- <el-popover placement="top-start" width="230" trigger="hover">
            <QRCode alt="" codeName="二维码"
              content="http://www.beijingxibao.com"
             :width="'200'" :height="'200'"></QRCode>
            
          <img slot="reference" src="/images/foot/2.png" alt="微信"  class="social-icon">
          </el-popover> -->

          
          <!-- <a href="https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http://www.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8"
            target="_blank"><img src="/images/foot/3.png" alt="QQ空间"></img></a>
          <a href="https://service.weibo.com/share/share.php?url=http://www.beijingxibao.com&title=%E5%8C%97%E4%BA%AC%E8%A5%BF%E5%AE%9D%E7%94%B5%E5%AD%90%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8"
            target="_blank"><img src="/images/foot/4.png" alt="微博"></img></a>
     
          <div v-if="showModal" class="modal-overlay" @click="hideQRCode">
            <div class="modal-content" @click.stop>
              <div class="modal-header">
                <span>{{ modalTitle }}</span>
                <button class="close-btn" @click="hideQRCode">×</button>
              </div>
              <div class="modal-body">
                <img :src="qrCodeUrl" :alt="modalTitle" class="modal-qr-code">
              </div>
            </div>
          </div> -->


        </div>
      </div>
    </div>
    <div class="foot-two">Copyright © 2026 北京西宝电子技术有限责任公司. All Rights Reserved. <span class="footer-link" @click="handleClick">京ICP备07039918号-2</span> </div>


  </footer>
</template>

<script>
import QRCode from './Qrcode.vue'

export default {
  name: 'Footer',

  components: {
    QRCode
  },
  data() {
    return {
      showModal: false,
      modalTitle: '',
      qrCodeUrl: ''
    }
  },
  methods: {
    showQRCode(type) {
      if (type === 'qq') {
        this.modalTitle = 'QQ二维码';
        this.qrCodeUrl = '/images/foot/qq-qr-code.png';
      } else if (type === 'wechat') {
        this.modalTitle = '微信二维码';
        this.qrCodeUrl = '/images/foot/wechat-qr-code.png';
      }
      this.showModal = true;
      document.body.style.overflow = 'hidden'; // 防止背景滚动
    },
    hideQRCode() {
      this.showModal = false;
      document.body.style.overflow = ''; // 恢复背景滚动
    },
    handleClick() {
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 768px) {
  .foot-two {
    /* height: 0vw; */
    font-weight: 400;
    font-size: 0.8vw !important;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.6;
    padding: 0.8vw 0 !important;
  }

  .foot {
    background-color: #007DC7;
    padding: 2vw 12vw 0vw 12vw;
    color: #fff;
  }

  /* .foot-logo{margin-bottom: 50px;} */
  .foot-logo img {
    height: 50px;
    display: block;
    margin-bottom: 1vw;
    margin-left: -0.6vw;
  }

  .foot-one {
    padding-bottom: 1.8vw;
    border-bottom: 1px solid #d3d3d3;



  }

  .foot-info {
    display: flex;
    /* justify-content: space-between; */
  }

  .foot-item-left {
    display: flex;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    width: 100%;
    



  }

  .foot-item {
    display: flex;
    flex-direction: column;
    width: calc(100% / 2);
    margin-top: 1vw;
    gap: 0.3vw;
    /* flex: 1; */
    /* width: 10px; */

  }

  .foot-item-title {
    font-weight: 500;
    font-size: 1vw;
  }

  .foot-desc {
    font-weight: 400;
    font-size: 0.8vw;
    opacity: 0.6;
    /* padding: 0.8vw 0; */
  }



  .foot-item-right  {
    flex: 1;
  }
   .foot-item-left {
    flex: 1.2;
  }

  .foot-item-right {
    width: 100%;
    display: flex;
    /* align-items: center; */
    margin-top: auto;
    /* margin-left: 50%; */
    /* margin:  0 auto; */
    justify-content: right;
    /* text-align: center; */
    gap: 1.5vw;
    /* justify-content: space-between; */
  }

  .foot-item-right img {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  .qr-code {
    width: 100px !important;
    height: 100px !important;
    display: block;
  }

  .social-icon {
    cursor: pointer;
  }

  /* 二维码弹窗样式 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .modal-content {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    max-width: 300px;
    width: 80%;
    max-height: 80%;
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
  }

  .modal-header span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .close-btn:hover {
    color: #333;
  }

  .modal-body {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-qr-code {
    width: 200px;
    height: 200px;
    max-width: 100%;
    max-height: 100%;
  }
}










@media only screen and (max-width: 768px) {
  .foot {
    background-color: #007DC7;
    padding: 5vw 4vw 0vw 4vw;
    color: #fff;
  }

  /* .foot-logo{margin-bottom: 50px;} */
  .foot-logo img {
    height: 50px;
    display: block;
    margin-bottom: 1vw;
    margin-left: -2.5vw;
  }

  .foot-one {
    padding-bottom: 1.8vw;
    border-bottom: 1px solid #d3d3d3;



  }

  .foot-info {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    gap: 2vw;
  }

  .foot-item-left {
    display: flex;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    width: 100%;

    /* gap: 1vw; */


  }

  .foot-item {
    display: flex;
    flex-direction: column;
    width: calc(100% / 2);
    margin-top: 1vw;
    margin-top: 2vw;
    /* gap: 0.3vw; */
    /* flex: 1; */
    /* width: 10px; */

  }

  .foot-item-title {
    font-weight: 500;
    font-size: 4vw;
  }

  .foot-desc {
    font-weight: 400;
    font-size: 3vw;
    opacity: 0.6;
    /* padding: 0.8vw 0; */
  }



  /* .foot-item-right .foot-item-left{
  flex: 1;
} */
  .foot-item-right {
    width: 100%;
    display: flex;

    margin-top: 2vw;

    gap: 4vw;

  }

  .foot-item-right img {
    width: 22px;
    height: 22px;
    cursor: pointer;
  }

  .qr-code {
    width: 100px !important;
    height: 100px !important;
    display: block;
  }

  .social-icon {
    cursor: pointer;
  }

  /* 二维码弹窗样式 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .modal-content {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    max-width: 300px;
    width: 80%;
    max-height: 80%;
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
  }

  .modal-header span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .close-btn:hover {
    color: #333;
  }

  .modal-body {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-qr-code {
    width: 200px;
    height: 200px;
    max-width: 100%;
    max-height: 100%;
  }
}

.foot-two {
  /* height: 0vw; */
  font-weight: 400;
  font-size: 2vw;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.6;
  padding: 3vw 0;
}

.footer-link {
  cursor: pointer;
  color: #FFFFFF;
 
  text-decoration: none;
  transition: opacity 0.3s ease-in-out;
  &:hover {
   opacity: 0.6 
  }
}
</style>